import { StudentRole } from '../../types';
import { StudentCreateValue, StudentUpdateValue } from './student.value';

export class StudentCreateValueDto {
    schoolId: string;
    pathIds: string[] = [];
    firstName: string;
    lastName: string;
    email: string;
    location: string;
    description: string;
    joinedAt: Date;
    role: StudentRole;
    avatarSrc: string;

    constructor(data: StudentCreateValue) {
        this.schoolId = data.schoolId;
        this.firstName = data.firstName;
        this.lastName = data.lastName;
        this.email = data.email;
        this.description = data.description;
        this.location = data.location;
        this.role = data.role;
        this.joinedAt = new Date();
        this.avatarSrc = `https://avatar.iran.liara.run/username?username=${this.firstName}+${this.lastName}`;
    }
}

export class StudentUpdateValueDto {
    firstName: string;
    lastName: string;
    email: string;
    location: string;
    description: string;
    avatarSrc: string;
    role: StudentRole;

    constructor(data: StudentUpdateValue) {
        this.firstName = data.firstName;
        this.lastName = data.lastName;
        this.email = data.email;
        this.description = data.description;
        this.location = data.location;
        this.role = data.role;
        this.avatarSrc = `https://avatar.iran.liara.run/username?username=${this.firstName}+${this.lastName}`;
    }
}
